import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  awaitingPayment: {
    description: 'salesOrderStatus.awaitingPayment',
    defaultMessage: 'Awaiting Payment',
    id: 'GdXcuK',
  },
  onHold: {
    description: 'salesOrderStatus.onHold',
    defaultMessage: 'On Hold',
    id: '0wOstF',
  },
  awaitingShipment: {
    description: 'salesOrderStatus.awaitingShipment',
    defaultMessage: 'Awaiting Shipment',
    id: 'lpYpCJ',
  },
  pendingFulfillment: {
    description: 'salesOrderStatus.pendingFulfillment',
    defaultMessage: 'Pending Fulfillment',
    id: '4dj+6Q',
  },
  rejectedFulfillment: {
    description: 'salesOrderStatus.rejectedFulfillment',
    defaultMessage: 'Rejected Fulfillment',
    id: '3/41ea',
  },
  pendingPickup: {
    description: 'salesOrderStatus.pendingPickup',
    defaultMessage: 'Pending Pickup',
    id: 'uNX/OC',
  },
  shipped: {
    description: 'salesOrderStatus.shipped',
    defaultMessage: 'Shipped',
    id: 'Uz9q59',
  },
  cancelled: {
    description: 'salesOrderStatus.cancelled',
    defaultMessage: 'Cancelled',
    id: 'CFfcvl',
  },
});
